import {createSlice, PayloadAction} from "@reduxjs/toolkit"

interface IAlertState {
  alertMsg: string
  isError: boolean
  severity?: "error" | "warning" | "info" | "success"
  btnText: string
  btnAction: () => void
  timeout: number | null
  horizontalPosition?: "left" | "center" | "right"
}

const initialState: IAlertState = {
  alertMsg: "",
  isError: false,
  btnText: "",
  btnAction: undefined,
  timeout: null,
  horizontalPosition: "left",
}

export const alertSlice = createSlice({
  initialState,
  name: "alert",
  reducers: {
    closeAlert: (state) => {
      state.alertMsg = ""
      state.btnText = ""
      state.btnAction = undefined
      state.timeout = null
      state.horizontalPosition = "left"
      state.severity = undefined
    },
    setAlert: (
      state,
      action: PayloadAction<{
        message: string
        isError?: boolean
        severity?: "error" | "warning" | "info" | "success"
        btnText?: string
        btnAction?: () => void
        timeout?: number | null
        horizontalPosition?: "left" | "center" | "right"
      }>,
    ) => {
      state.alertMsg = action.payload.message
      state.isError = action.payload.isError || false
      state.severity = action.payload.severity
      state.btnText = action.payload.btnText || ""
      state.btnAction = action.payload.btnAction || undefined
      state.timeout = action.payload.timeout !== undefined ? action.payload.timeout : 3000
      state.horizontalPosition = action.payload.horizontalPosition || "left"
    },
  },
})

export const { closeAlert, setAlert } = alertSlice.actions
export default alertSlice.reducer
